import mappedItemTypes from "services/items/mappedItemTypes";
import { PCW_STEPS } from "../constants";
import { PortfolioItemSelectStep } from "../PortfolioItemSelectStep";

export default function BatteryStorageStep() {
  return (
    <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_ADD_BATTERY_STEP_ID}
            itemTypeIds={[
                mappedItemTypes.BATTERY_STORAGE.id,
            ]}
        />
  )
}
